'use client'

import {createWithEqualityFn} from 'zustand/traditional'

interface AppState {
	isPanelOpened: boolean
	setIsPanelOpened: (boolean) => void
}

export const useCookieConsentStore = createWithEqualityFn<AppState>(set => ({
	isPanelOpened: false,
	setIsPanelOpened: value => set(() => ({
		isPanelOpened: value,
	})),
}))
